import React, { useState } from "react";
import { useT } from "@/i18n/i18n";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Field, Input, Textarea, Select, Btn } from "@/pages/app/kit";
import { CheckCircle2 } from "lucide-react";

const ROLES = [
  ["farmer", "Rolnik / Farmer"], ["school", "Szkoła / School"], ["hospital", "Szpital / Hospital"],
  ["senior_care", "Opieka senioralna / Senior care"], ["military", "Wojsko / Military"],
  ["employer", "Pracodawca / Employer"], ["processor", "Przetwórca / Processor"],
  ["logistics", "Logistyka / Logistics"], ["municipality", "Samorząd / Municipality"],
  ["bank", "Bank spółdzielczy / Cooperative bank"], ["investor", "Inwestor / Investor"],
  ["researcher", "Badacz / Researcher"], ["other", "Inne / Other"],
];

export default function Contact() {
  const { lang } = useT();
  const L = (pl, en) => (lang === "pl" ? pl : en);
  const [form, setForm] = useState({ role: "farmer", name: "", organization: "", email: "", phone: "", region: "", message: "" });
  const [done, setDone] = useState(null);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/leads", form);
      setDone(data.reference);
      toast.success(L("Zgłoszenie zapisane", "Interest submitted"));
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div className="mx-auto max-w-2xl px-4 py-16">
      <h1 className="font-heading text-3xl font-bold text-charcoal sm:text-4xl">{L("Kontakt i zainteresowanie pilotażem", "Contact & pilot interest")}</h1>
      <p className="mt-3 text-mutedtext">{L("Wybierz swoją rolę i zostaw dane — zgłoszenie trafi do administratora.", "Select your role and leave your details — it reaches the administrator CRM.")}</p>

      {done ? (
        <div className="mt-8 rounded-md border border-forest/20 bg-forest/5 p-8 text-center" data-testid="contact-success">
          <CheckCircle2 className="mx-auto h-10 w-10 text-forest" aria-hidden="true" />
          <p className="mt-3 font-semibold text-charcoal">{L("Dziękujemy!", "Thank you!")}</p>
          <p className="mt-1 text-sm text-mutedtext">{L("Numer zgłoszenia", "Reference")}: <span className="font-mono">{done}</span></p>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="contact-form">
          <Field label={L("Rola", "Role")} required><Select data-testid="contact-role" value={form.role} onChange={set("role")}>{ROLES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}</Select></Field>
          <Field label={L("Imię i nazwisko / nazwa", "Name")} required><Input data-testid="contact-name" required value={form.name} onChange={set("name")} /></Field>
          <Field label={L("Organizacja", "Organization")}><Input data-testid="contact-org" value={form.organization} onChange={set("organization")} /></Field>
          <div className="grid gap-4 sm:grid-cols-2">
            <Field label="E-mail"><Input data-testid="contact-email" type="email" value={form.email} onChange={set("email")} /></Field>
            <Field label={L("Telefon", "Phone")}><Input data-testid="contact-phone" value={form.phone} onChange={set("phone")} /></Field>
          </div>
          <Field label={L("Region", "Region")}><Input data-testid="contact-region" value={form.region} onChange={set("region")} placeholder="Lubelskie" /></Field>
          <Field label={L("Wiadomość", "Message")}><Textarea data-testid="contact-message" rows={4} value={form.message} onChange={set("message")} /></Field>
          <Btn type="submit" disabled={busy} data-testid="contact-submit">{busy ? "…" : L("Wyślij", "Submit")}</Btn>
        </form>
      )}
    </div>
  );
}
